import { collection, doc, setDoc } from 'firebase/firestore';
import { startOfDay, addDays, eachDayOfInterval } from 'date-fns';

// 連携直後に遡って取り込む日数。
// 上限は Amazon 側の保持期間で決まる（広告レポートはスポンサープロダクトで約95日、
// スポンサーブランド/ディスプレイは約60日）。60日はいずれにも収まる安全圏。
export const BACKFILL_DAYS = 60;

// ショップ連携の完了直後に売上データを取り込むためのジョブを作成する。
// 定期実行と同じ形式で、テナントの全セラー・全モールショップ × 直近日付分が計算される。
export default async function createComputeSalesJob(tenant) {
  const now = new Date();
  const dates = eachDayOfInterval({ start: addDays(now, -2), end: now }).map(_ => startOfDay(_));
  await setDoc(doc(collection(tenant.ref, 'computeSalesJobs')), { dates, createdAt: new Date() });
}

// Amazon セラーの「裏で商品取得 → 完了後に売上 backfill」を開始する。
// 商品マスタが無いと商品別売上が紐づかないため、backfill は連携時ではなく
// 商品同期(syncAmazonProductsJobs)の完了時にサーバ側(onCreateSyncAmazonProductsJob)で積む。
// backfillAfter: true がその起点フラグ。広告 backfill は ad account 紐付け完了時に別途有効化される。
export async function startAmazonSyncAndBackfill(tenant, sellerId) {
  await setDoc(doc(collection(tenant.ref, 'syncAmazonProductsJobs')), {
    status: 'initial',
    version: 2,
    sellerId,
    backfillAfter: true,
    createdAt: new Date(),
  });
}

// 楽天ショップの「裏で商品取得 → 完了後に売上 backfill」を開始する。
// computeRakutenSales も商品マスタ(products)を参照するため、Amazon と同様に
// 商品同期の完了を待ってから backfill を積む(onCreateSyncRakutenProductsJob)。
export async function startRakutenSyncAndBackfill(tenant, shopId) {
  await setDoc(doc(collection(tenant.ref, 'syncRakutenProductsJobs')), {
    status: 'initial',
    shopId,
    backfillAfter: true,
    createdAt: new Date(),
  });
}

// Shopify ショップの「裏で商品取得 → 完了後に売上 backfill」を開始する。
// OAuth インストール完了後でないとトークンが無く商品を取得できないため、
// 店舗登録時ではなくインストール後に呼ぶ(onCreateSyncShopifyProductsJob)。
export async function startShopifySyncAndBackfill(tenant, shopId) {
  await setDoc(doc(collection(tenant.ref, 'syncShopifyProductsJobs')), {
    status: 'initial',
    shopId,
    backfillAfter: true,
    createdAt: new Date(),
  });
}

// Yahoo ショップの「裏で商品取得 → 完了後に売上 backfill」を開始する。
// OAuth 認証完了後でないとトークンが無く商品を取得できないため、
// 店舗登録時ではなく認証後に呼ぶ(onCreateSyncYahooProductsJob)。
export async function startYahooSyncAndBackfill(tenant, shopId) {
  await setDoc(doc(collection(tenant.ref, 'syncYahooProductsJobs')), {
    status: 'initial',
    shopId,
    backfillAfter: true,
    createdAt: new Date(),
  });
}
